<div class="flex flex-col gap-4 relative">
  <!-- header -->
  <div class="flex flex-col gap-1">
    <h2 class="text-[#7f7f7f] text-xs uppercase font-medium">
      {{
        'RESULT.KPIS.EXPORT_OPTIONS.XLSX_METADATA.APPLIED_FILTERS' | translate
      }}
    </h2>
    <!-- horizontal divider -->
    @if (this.showChipIsAvailable()) {
      <mat-divider />
    }
  </div>

  <!-- hint if nothing or all selected -->
  @if (shownAppliedFilters().length === 0) {
    <p class="italic font-thin text-xs">
      {{ 'UTILITY.NOTHING_SELECTED' | translate }}
    </p>
  }

  <!-- visible wrapper for all filter chips -->
  @if (this.showChipIsAvailable()) {
    <div
      id="applied-filter-chips-wrapper"
      #appliedFilterChipsWrapper
      class="flex flex-wrap items-start content-start overflow-hidden relative"
      [ngStyle]="{
        gap: this.GAP_BETWEEN_CHIPS + 'px',
      }"
      [@fadeAnimation]
      [@heightChange]="{
        value: isOpened ? 'open' : 'closed',
      }"
    >
      @for (
        filter of this.shownAppliedFilters();
        track $index;
        let i = $index
      ) {
        <mat-chip
          [ngStyle]="{
            'background-color': filter.backgroundColor,
          }"
          class="transition-all duration-300 ease-in-out"
          [disableRipple]="true"
          [@fadeAnimation]
          >{{ filter.label }}
        </mat-chip>
      }
      <!-- show hint how many filters are not shown -->
      @if (this.leftOverFilters() !== null && this.leftOverFilters() > 0) {
        <mat-chip
          [ngStyle]="{
            'background-color': '#ffffff',
            color: '#202020',
            border: 'none',
          }"
          class="transition-all duration-300 ease-in-out"
          [disableRipple]="true"
          [disabled]="true"
          [@fadeAnimation]
          ><span class="italic font-semibold"
            >{{ this.leftOverFilters() }}
            {{ 'UTILITY.MORE' | translate }} ...</span
          >
        </mat-chip>
      }
      <!-- shadow if toggle is visible -->
      <div
        [ngStyle]="{
          height: this.CHIP_HEIGHT * 2 + this.GAP_BETWEEN_CHIPS + 'px',
          opacity: this.toggleNeeded && this.isOpened === false ? 1 : 0,
          zIndex: this.toggleNeeded && this.isOpened === false ? 1 : -1,
        }"
        class="absolute inset-x-0 bottom-0 bg-gradient-to-b from-transparent to-white transition-all duration-700 ease-in-out"
      ></div>
    </div>
  }

  <!-- DO NOT REMOVE, this is to dynamically calc height of all chips; could and should be optimized later -->
  <div
    id="calc-filter-height"
    #calcHeightElement
    class="flex flex-wrap items-start content-start absolute top-0 opacity-0 pointer-events-none -z-10"
    [ngStyle]="{
      gap: this.GAP_BETWEEN_CHIPS + 'px',
    }"
    (cdkObserveContent)="chipsChanged()"
  >
    @for (filter of shownAppliedFilters(); track $index; let i = $index) {
      <mat-chip [disableRipple]="true">{{ filter.label }} </mat-chip>
    }
    <!-- show hint how many filters are not shown -->
    @if (this.leftOverFilters() > 0) {
      <mat-chip
        class="transition-all duration-300 ease-in-out"
        [disableRipple]="true"
        [disabled]="true"
        [@fadeAnimation]
      >
        <span class="italic font-semibold">
          {{ this.leftOverFilters() }}
          {{ 'UTILITY.MORE' | translate }} ...
        </span>
      </mat-chip>
    }
  </div>

  <!-- collapse button -->
  @if (
    this.toggleNeeded &&
    this.appliedFilterChipsService.appliedFilters().size > 0
  ) {
    <div
      #collapseBar
      id="collapse-button"
      [@fadeAnimation]
      class="z-10 flex justify-center items-center flex-row w-full sticky bottom-0 left-0 bg-gradient-to-b from-transparent to-white transition-all duration-700 ease-in-out"
    >
      <pm-icon [icon]="dropdownIcon"></pm-icon>
    </div>
  }
</div>
